import styled from 'styled-components';

const Banner = styled.aside`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 2rem;

  background: #333b3d;
  color: white;
`;

export default Banner;
